const MASK = '****';

export function maskFirstName(name) {
  if (!name) return '';
  const trimmed = name.trim();
  if (trimmed.length <= 2) return `${trimmed}${MASK}`;
  return `${trimmed.slice(0, 2)}${MASK}`;
}

export function maskLastName(name) {
  if (!name) return '';
  const trimmed = name.trim();
  if (trimmed.length <= 2) return `${MASK}${trimmed}`;
  return `${MASK}${trimmed.slice(-2)}`;
}

export function maskFullName(firstname, lastname) {
  return `${maskFirstName(firstname)} ${maskLastName(lastname)}`.trim();
}
